import { setCountAction } from "./_common";

const main = () => {
    if (document.querySelector('#page-search-area') === null) return;
    setCountAction();
}

export default main;
